import { PublicClientApplication, EventType, EventMessage, AccountInfo } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "../../configurations/authConfig";
import { RdProvider } from "../../contexts/RdProvider"
import { HelmetProvider } from 'react-helmet-async';
import { EmotionCacheKey, cacheEmotion } from "../../configurations/CSP/Emotion";
import { CacheProvider } from '@emotion/react';
import { HelmentCacheKey, HelmentContext } from "../../configurations/CSP/Helmet";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../configurations/styles/Theme.scss";
import React from "react";
import { TypeChecker } from "../../Helpers/TypeHelper";
import "../../configurations/MuiLicense";


/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
const msalInstance = new PublicClientApplication(msalConfig);

// Account selection logic is app dependent. Adjust as needed for different use cases.
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

/**
 * To set an active account after the user signs in, register an event and listen for LOGIN_SUCCESS and LOGOUT_SUCCESS. For more,
 * visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/events.md
 */
msalInstance.addEventCallback((message: EventMessage) => {
    const { eventType, payload, error, ...rest } = message,
        account = (payload != null && TypeChecker<AccountInfo>(payload) && payload as AccountInfo) || undefined;

    if (eventType != null && eventType === EventType.LOGIN_SUCCESS && account != null) {
        msalInstance.setActiveAccount(account);
    }
});

const Startup = (): JSX.Element => {

    return (
        <React.StrictMode>
            <MsalProvider instance={msalInstance}>
                <HelmetProvider key={HelmentCacheKey} context={HelmentContext}>
                    <CacheProvider key={EmotionCacheKey} value={cacheEmotion}>
                        <RdProvider />
                    </CacheProvider>
                </HelmetProvider>
            </MsalProvider>
        </React.StrictMode >
    )
}

export default Startup;